import { useQuery } from "@tanstack/react-query";

import {
  getPartners,
  type PartnerListSortColumn,
  type PartnerStatus,
  type SortOrder,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "./queryKeys";

export interface PartnersQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string | null;
  sortBy?: PartnerListSortColumn;
  sortOrder?: SortOrder;
  statusFilter?: PartnerStatus[] | null;
  enabled?: boolean;
}

export function usePartnersQuery(params: PartnersQueryParams) {
  return useQuery({
    queryKey: PARTNERS_QUERY_KEYS.overview(params),
    queryFn: processResponse(() =>
      getPartners(
        params.offset,
        params.limit,
        params.searchQuery,
        params.sortBy,
        params.sortOrder,
        params.statusFilter,
      ),
    ),
    enabled: params.enabled ?? true,
  });
}
